<template>
    <div class="d-flex align-items-center" style="gap: 5px">
        <a v-if="type === 'asin'" :href="`https://www.amazon.com/dp/${asin}`" target="_blank">{{ asin }}</a>
        <a v-if="type === 'sku'" :href="`https://www.${getAmazonCountryURL}/dp/${asin}`" target="_blank">{{ sku }}</a>
        <a v-if="type === 'order-id'" :href="`/orders/${orderId}`" target="_blank">{{ orderId }}</a>
        <Popper style="line-height: 1; border: 0 !important; margin: 0 !important" hover arrow>
            <template #content>{{ isCopied ? $t('views.extension.copied') : $t('views.extension.copyClipboard') }}</template>
            <button type="button" class="btn btn-link p-0" style="line-height: 1; border: 0 !important" @click="clipboard(text)">
                <font-awesome-icon :icon="isCopied ? ['fas', 'check'] : ['far', 'copy']" />
            </button>
        </Popper>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { countryInfo } from '@/utils/helper'

const countries = countryInfo()

export default {
    name: 'InventoryClipboard',
    props: {
        type: { type: String, default: 'asin' },
        asin: { type: String },
        sku: { type: String },
        orderId: { type: String },
    },
    data() {
        return {
            isCopied: false,
        }
    },
    computed: {
        ...mapGetters('market', ['currentMarket']),
        getAmazonCountryURL() {
            return countries[this.currentMarket.short].domain
        },
        text() {
            switch (this.type) {
                case 'asin':
                    return this.asin
                case 'sku':
                    return this.sku
                case 'order-id':
                    return this.orderId
                default:
                    return ''
            }
        },
    },
    methods: {
        clipboard(value) {
            window.navigator.clipboard.writeText(value)
            this.isCopied = true
            setTimeout(() => {
                this.isCopied = false
            }, 2500)
        },
    },
}
</script>

<style lang="scss" scoped>
a {
    color: #ffb53e;
    font-weight: 600;
    text-decoration: underline;
}
svg {
    color: #677788;
    font-size: 13px;
}
</style>
